import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
//import TopSection from '../components/TopSection';
//import TopMenu from '../components/TopMenu';
//import BigTitle from '../components/BigTitle';
//import SearchField from '../components/SearchField';
//import SlidingGallery from '../components/SlidingGallery';
import SimpleSection from '../components/SimpleSection';
import AboutLayout from '../layouts/AboutLayout';
//import GLIFOSViewer from '../viewer/GLIFOSViewer';//
//import GLIFOSCollectionViewer from '../viewer/GLIFOSCollectionViewer';
//import TreeView from '../components/TreeView';
//import SearchToolbar from '../components/SearchToolbar';
import {House} from 'react-bootstrap-icons';
import FG005back from "../images/backgrounds/GT-CIRMA-FG-005.jpg";
import { Link } from 'react-router-dom';


const collectionInfo={
	id:"GT-CIRMA-FG-005",
	title: "secciones",
	subtitle: "secciones"
};

document.addEventListener('DOMContentLoaded', function () {
	//console.log('Dom loaded');
	window.addEventListener('scroll', function () {
		let navbar_height =
			document.getElementById('c-top-navbar').offsetHeight;
		//console.log('Scroll event',window.scrollY);
		if (window.scrollY > navbar_height + 50) {
			document.getElementById('c-top-navbar').classList.add('fixed-top');
			// add padding top to show content behind navbar
			//let navbar_height = document.querySelector('.navbar').offsetHeight;
			//document.body.style.paddingTop = navbar_height + 'px';
			document.getElementById('c-nav-bar-fixer').style.height =
				navbar_height + 'px';
			document.getElementById('navbar-logo').style.width = '70px';
			document.getElementById('navbar-logo').style.height = '55px';
		} else {
			document
				.getElementById('c-top-navbar')
				.classList.remove('fixed-top');
			document.getElementById('c-nav-bar-fixer').style.height = 'auto';
			// remove padding top from body
			//document.body.style.paddingTop = '0';
			document.getElementById('navbar-logo').style.width = '100px';
			document.getElementById('navbar-logo').style.height = '76px';
		}
	});
});





export default function PrimaryScreen(props) {
	return (
			<AboutLayout title={collectionInfo.title} subtitle={collectionInfo.subtitle} backgroundImage={FG005back}
			subtitleIcon={<House />} agencyData={{id:'GT-CIRMA-AH',name:"secciones"}}>
				<SimpleSection className='c-welcome-cirma'>
					<Container>
						<Row>
							<Col>
								<Link to={process.env.PUBLIC_URL+"/agency/GT-CIRMA-FG"}><h1>Fototeca Guatemala</h1></Link>
								<Link to={process.env.PUBLIC_URL+"/agency/GT-CIRMA-FG"}><h1>Archivo Histórico</h1></Link>
							</Col>
						</Row>
					</Container>
				</SimpleSection>
			</AboutLayout>
	);
}
